/**
 * Generates a unique id for offline punch sessions.
 * Prefers crypto.randomUUID when available; falls back for older WebViews.
 */
export function generateId() {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    try {
      return crypto.randomUUID();
    } catch {
      // Fall through when randomUUID is unavailable at runtime.
    }
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
